<template>
  <div class="sidebar">
    <div class="logo">
      <div class="logo-icon">
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M24 8L12 20h8v12H8l12 12 12-12h-8V20h8L24 8z"
            fill="#22c55e"
          />
        </svg>
      </div>
      <span class="logo-text">巡山客</span>
    </div>
    <div class="menu-container">
      <el-menu
        :default-active="$route.path"
        class="el-menu-vertical-demo"
        router
      >
        <el-menu-item index="/dashboard">
          <i class="el-icon-house"></i>
          <span>首页</span>
        </el-menu-item>
        <el-submenu index="2">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span>核心业务</span>
          </template>
          <el-menu-item index="/routes">
            <i class="el-icon-location"></i>
            <span>线路管理</span>
          </el-menu-item>
          <!-- <el-menu-item index="/leaders">
            <i class="el-icon-user"></i>
            <span>领队管理</span>
          </el-menu-item>
          <el-menu-item index="/orders">
            <i class="el-icon-document"></i>
            <span>订单管理</span>
          </el-menu-item>
          <el-menu-item index="/reports">
            <i class="el-icon-s-data"></i>
            <span>运营报表</span>
          </el-menu-item> -->
        </el-submenu>
        <el-menu-item index="/users">
          <i class="el-icon-user-solid"></i>
          <span>用户管理</span>
        </el-menu-item>
        <!-- <el-menu-item index="/settings">
          <i class="el-icon-setting"></i>
          <span>系统设置</span>
        </el-menu-item> -->
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  data() {
    return {
      isGroupExpanded: true
    }
  },
  methods: {
    toggleGroup() {
      this.isGroupExpanded = !this.isGroupExpanded
    }
  }
}
</script>

<style scoped>
.sidebar {
  width: 200px;
  background-color: #ffffff;
  min-height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  border-right: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
}

.logo {
  display: flex;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
}

.logo-icon {
  width: 36px;
  height: 36px;
  background-color: #dcfce7;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.logo-icon svg {
  width: 20px;
  height: 20px;
}

.logo-text {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.menu-container {
  flex: 1;
  padding: 16px 0;
}

.menu-group {
  margin-bottom: 8px;
}

.group-title {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: #374151;
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.group-title:hover {
  background-color: #f9fafb;
}

.group-title i:first-child {
  margin-right: 8px;
  font-size: 14px;
}

.expand-icon {
  margin-left: auto;
  font-size: 12px;
  color: #9ca3af;
  transition: transform 0.2s;
}

.menu-items {
  padding: 0 8px;
  max-height: 500px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.menu-items.collapsed {
  max-height: 0;
  padding: 0 8px;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  margin: 4px 0;
  border-radius: 8px;
  color: #6b7280;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.menu-item:hover {
  background-color: #f0fdf4;
  color: #22c55e;
}

.menu-item.active {
  background-color: #f0fdf4;
  color: #22c55e;
}

.menu-item i {
  margin-right: 10px;
  font-size: 14px;
}
</style>
